import React from "react";
import {
  Accordion,
  Box,
  MarkdownLite,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { INTERNET_OFFER_CONTENT } from "@origin-digital/sales-offer-content";

export const InternetOfferAccordion = () => (
  <Accordion
    id={INTERNET_OFFER_CONTENT.dataId}
    data-id={INTERNET_OFFER_CONTENT.dataId}
    variant="outlined"
    image={INTERNET_OFFER_CONTENT.iconUrl}
    defaultExpanded
    summary={<Text weight="medium">{INTERNET_OFFER_CONTENT.title}</Text>}
  >
    <Stack space="medium">
      <Box>
        <Text>
          <MarkdownLite>
            {INTERNET_OFFER_CONTENT.promotionalOfferMarkdown}
          </MarkdownLite>
        </Text>
      </Box>
      <Box>
        <Text>
          <MarkdownLite>
            {INTERNET_OFFER_CONTENT.ongoingBundleDiscountMarkdown}
          </MarkdownLite>
        </Text>
      </Box>
    </Stack>
  </Accordion>
);
